/**
 * TanStack Query hooks for `clevertap-2-way-apptrove-native-sync`.
 * Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	patch,
	nativeSyncQueryKeys,
	type CreateNativeSyncBody,
	type CreateNativeSyncResponse,
	type ListNativeSyncResponse,
	type PatchNativeSyncBody,
} from "./api";

export function useNativeSyncList(): UseQueryResult<ListNativeSyncResponse, Error> {
	return useQuery({
		queryKey: nativeSyncQueryKeys.list(),
		queryFn: list,
	});
}

export function useNativeSyncCreate(): UseMutationResult<CreateNativeSyncResponse, Error, CreateNativeSyncBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: nativeSyncQueryKeys.all });
		},
	});
}

export function useNativeSyncPatch(): UseMutationResult<
	{ ok: true; id: string } & Record<string, unknown>,
	Error,
	{ id: string; body: PatchNativeSyncBody }
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ id, body }) => patch(id, body),
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: nativeSyncQueryKeys.all });
		},
	});
}
